import { faBroom } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react"
import { EyeFill, EyeSlashFill, Search } from "react-bootstrap-icons";
import DatePicker from "react-datepicker2";
import { Controller, useForm } from "react-hook-form";
import { workItemSeverity, workItemTypes } from "../../../store/api/CommonFunctions";
import { getWorkItemsBaseInfoes } from "../../store/api/workItemsApi";
import { Button, Col, Row } from "react-bootstrap";
import Loader from "react-loader-spinner";
import BihamtaMultiSelect from "../../../Components/BihamtaMultiSelect";
import { getBaseInfoList } from "../../../BaseInfo/store/api/BaseInfoApi";

export default function SearchFilters({ onSubmit, defaultValues }) {
    const frmFiltersRef = useRef();
    const divFiltersRef = useRef();
    const selectedLabelsRef = useRef([]);
    const selectedStatusRef = useRef([]);
    const [showFilters, setShowFilters] = useState(true);
    const [workItemBaseInfoes, setWorkItemBaseInfoes] = useState(null);
    const [labels, setLabels] = useState([]);
    const { handleSubmit, control, register } = useForm({ defaultValues: defaultValues });
    const [defaultStatusList, setDefaultStatusList] = useState();


    const clearFilters = () => {

    }
    const showHideFilter = (hide) => {
        const divFilters = divFiltersRef.current;
        setShowFilters(prev => !prev);
        if (hide) {
            divFilters.classList.add("hiddenRow");
        }
        else {
            divFilters.classList.remove("hiddenRow");
        }
    }
    const getWorkItemInfoes = async () => {
        setWorkItemBaseInfoes("PENDING");
        const result = await getWorkItemsBaseInfoes();
        if (result?.Data) {
            setWorkItemBaseInfoes(result.Data);
        }
    }
    const handleSelectLabel = (item) => {
        if (!selectedLabelsRef.current) {
            selectedLabelsRef.current = [];
        }
        const splited = item.value.split(",");
        if (item.checked) {
            selectedLabelsRef.current = [
                ...new Set([...selectedLabelsRef.current, ...splited])
            ];
        } else {
            selectedLabelsRef.current = selectedLabelsRef.current.filter(
                a => !splited.includes(a)
            );
        }
    }
    const handleSelectStatus = (item) => {
        if (!selectedStatusRef.current) {
            selectedStatusRef.current = [];
        }
        const splited = item.value.split(",");
        if (item.checked) {
            selectedStatusRef.current = [
                ...new Set([...selectedStatusRef.current, ...splited])
            ];
        } else {
            selectedStatusRef.current = selectedStatusRef.current.filter(
                a => !splited.includes(a)
            );
        }
    }
    const handleSearch = (data) => {
        onSubmit({
            ...data,
            Skip: 0,
            LabelIds: selectedLabelsRef.current,
            StatusIds: selectedStatusRef.current
        })
    }
    useEffect(() => {
        getWorkItemInfoes();
        getBaseInfoList(45, setLabels);
    }, [])
    return (
        <form onSubmit={handleSubmit(handleSearch)} ref={frmFiltersRef}>
            <Row ref={divFiltersRef} className="rowBorder mt-4" >
                <div className="rowTitle">
                    فیلترهای جستجو
                    &nbsp;
                    {showFilters && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                    {!showFilters && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                    {showFilters && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                </div>
                <Col md={2} className="form-group">
                    <label>نوع:</label>
                    <select className="search-input" name="Type" ref={register({})} defaultValue={defaultValues?.Type ?? ""}>
                        <option value="">انتخاب کنید</option>
                        <option value={workItemTypes.bug}>باگ</option>
                        <option value={workItemTypes.changeRequest}>درخواست تغییر</option>
                        <option value={workItemTypes.feature}>امکان جدید</option>
                        <option value={workItemTypes.improvement}>بهینه‌سازی</option>
                        <option value={workItemTypes.task}>وظیفه</option>
                    </select>
                </Col>
                <Col md={2} className="form-group">
                    <label>دسته‌بندی:</label>
                    {
                        workItemBaseInfoes == "PENDING" ?
                            <div className="search-input">
                                <Loader type="BallTriangle" width={21} height={21} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                در حال بارگذاری فهرست...
                            </div> :
                            <select className="search-input" name="CategoryID" ref={register({})} defaultValue={defaultValues?.CategoryID ?? ""}>
                                <option value="">انتخاب کنید</option>
                                {Array.isArray(workItemBaseInfoes?.CategoryList) &&
                                    workItemBaseInfoes.CategoryList.map((s, i) =>
                                        <option key={i} value={s.ID}>{s.InfoName}</option>)
                                }
                            </select>
                    }
                </Col>
                <Col md={2} className="form-group">
                    <label>اهمیت:</label>
                    <select className="search-input" name="Severity" ref={register({})} defaultValue={defaultValues?.Severity ?? ""}>
                        <option value="">انتخاب کنید</option>
                        <option value={workItemSeverity.critical}>فوری</option>
                        <option value={workItemSeverity.major}>زیاد</option>
                        <option value={workItemSeverity.medium}>متوسط</option>
                        <option value={workItemSeverity.minor}>کم</option>
                        <option value={workItemSeverity.trivial}>بسیار پایین</option>
                    </select>
                </Col>
                <Col md={2} className="form-group">
                    <label>اولویت:</label>
                    <select className="search-input" name="Priority" ref={register({})} defaultValue={defaultValues?.Priority ?? ""}>
                        <option value="">انتخاب کنید</option>
                        <option value={4}>بسیار بالا</option>
                        <option value={3}>بالا</option>
                        <option value={2}>نرمال</option>
                        <option value={1}>پایین</option>
                    </select>
                </Col>
                <Col md={2} className="form-group">
                    <label>ثبت از:</label>
                    <Controller
                        name="CreationDateFrom"
                        control={control}
                        render={({ onChange, value }) => (
                            <DatePicker
                                className="search-input"
                                isGregorian={false}
                                timePicker={false}
                                value={value}
                                onChange={onChange}
                                setTodayOnBlur={false}
                            />
                        )}
                    />
                </Col>
                <Col md={2} className="form-group">
                    <label>ثبت تا:</label>
                    <Controller
                        name="CreationDateTo"
                        control={control}
                        render={({ onChange, value }) => (
                            <DatePicker
                                className="search-input"
                                isGregorian={false}
                                timePicker={false}
                                value={value}
                                onChange={onChange}
                                setTodayOnBlur={false}
                            />
                        )}
                    />
                </Col>
                <Col md={2} className="form-group">
                    <label>برچسب‌ها</label>
                    {Array.isArray(labels?.Data) ?
                        <BihamtaMultiSelect
                            className="search-input"
                            placeholder="انتخاب برچسب"
                            dataSource={labels.Data} valueItem="ID" displayItem="InfoName"
                            onItemCheckChanged={handleSelectLabel}
                            defaultCheckedList={defaultValues?.LabelIds} /> :
                        <div className="search-input">
                            <Loader width={20} height={20} color="#bb1370" type="BallTriangle" />
                        </div>
                    }
                </Col>
                <Col md={2} className="form-group">
                    <label>وضعیت‌ها</label>
                    {Array.isArray(labels?.Data) ?
                        <BihamtaMultiSelect
                            className="search-input"
                            placeholder="انتخاب وضعیت"
                            dataSource={workItemBaseInfoes.StatusList} valueItem="Id" displayItem="Name"
                            onItemCheckChanged={handleSelectStatus}
                            defaultCheckedList={defaultValues?.StatusIds} /> :
                        <div className="search-input">
                            <Loader width={20} height={20} color="#bb1370" type="BallTriangle" />
                        </div>
                    }
                </Col>
                <Col md={2} className="form-group">
                    <label>شماره:</label>
                    <input
                        className="search-input"
                        name="Number"
                        ref={register({})}
                        defaultValue={defaultValues?.Number ?? ""} />
                </Col>
            </Row>
            <Button type="submit" className="mt-1"><Search size={18} />&nbsp; جستجو</Button>
        </form>

    )
}